/* eslint-disable */

import { checkIsMobile } from '../platformUtils';
import { isCrefitApp, isDev, isEkycWebview } from '../util';
import { crefitNative } from './crefit';
import { NativeApi, Platform } from './interface';
import { mobileWebClient } from './mobileWebClient';
import { mylink } from './mylink';
import { pcWebClient } from './pcWebClient';

const devDefaultClient = crefitNative;

const isMylink = () => navigator.userAgent.indexOf('hshhk') > -1;

export const getNativeClient = () => {
  let nativeApi: NativeApi = crefitNative;
  switch (true) {
    case isMylink():
      nativeApi = mylink;
      break;
    case isCrefitApp():
      nativeApi = crefitNative;
      break;
    case isEkycWebview():
      nativeApi = mobileWebClient;
      nativeApi.name = Platform.EkycWebview;
      break;
    case checkIsMobile():
      // 移动端web
      nativeApi = mobileWebClient;
      break;
    default:
      // 普通web H5页面
      nativeApi = isDev() ? devDefaultClient : pcWebClient;
      break;
  }
  return isDev() ? devDefaultClient : nativeApi;
};

export let nativeApi = getNativeClient();

setTimeout(() => {
  nativeApi = getNativeClient();
  window.nativeApi = nativeApi;
}, 500);
